// Free-plan template trials used in this browser (localStorage). Kept apart
// from the hook so the public template pages can mark a trial without
// bundling useUser.
const TRIAL_STORAGE_KEY = 'template-trials-used';

export function readTrialsUsed(): string[] {
  try {
    const stored = localStorage.getItem(TRIAL_STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Records that this browser used its free try of a template. Also called by
 * the public template page after an anonymous run, so the dashboard shows the
 * upgrade screen for that template once the visitor signs up.
 */
export function markTemplateTrialUsed(slug: string): string[] {
  if (typeof window === 'undefined' || !slug) return [];
  const trials = readTrialsUsed();
  if (trials.includes(slug)) return trials;
  const next = [...trials, slug];
  try {
    localStorage.setItem(TRIAL_STORAGE_KEY, JSON.stringify(next));
  } catch (error) {
    console.error('Error saving trial data:', error);
  }
  return next;
}
